/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Url_Error_Domain_FinanceInputs */

const en_site_url_error_domain_finance = /** @type {(inputs: Site_Url_Error_Domain_FinanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banking, e-wallet, payment and sign-in sites cannot be dissected (phishing risk).`)
};

const id_site_url_error_domain_finance = /** @type {(inputs: Site_Url_Error_Domain_FinanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Situs bank, dompet digital, pembayaran, dan login tidak bisa dibedah (risiko phishing).`)
};

/**
* | output |
* | --- |
* | "Banking, e-wallet, payment and sign-in sites cannot be dissected (phishing risk)." |
*
* @param {Site_Url_Error_Domain_FinanceInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_url_error_domain_finance = /** @type {((inputs?: Site_Url_Error_Domain_FinanceInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Url_Error_Domain_FinanceInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_url_error_domain_finance(inputs)
	return en_site_url_error_domain_finance(inputs)
});